<div layout-vertical class="card-container">
  <rt-form-field [required]="!nameControl.valid" margin-bottom-medium class="card-holder-name">
    <rt-label>{{ 'app.stripe.name' | translate }}</rt-label>
    <rt-input
      variant="rounded"
      [formControl]="nameControl"
      [placeholder]="'app.stripe.name_placeholder' | translate"
    />
  </rt-form-field>
  <div margin-bottom-medium layout>
    <rt-form-field [required]="!cardNumberComplete$.getValue()" class="card-number">
      <rt-label>{{ 'app.stripe.number' | translate }}</rt-label>
      <div layout layout-align-items-center>
        <div #cardNumber class="field" layout-full-width></div>
        <rt-icon
          [name]="brand | rtCreditCardVendorIcon: 'credit-card'"
          size="large"
          margin-left-medium
        />
      </div>
    </rt-form-field>
  </div>
  <div layout layout-align-items-start>
    <rt-form-field [required]="!cardExpiryComplete$.getValue()" class="card-expiry">
      <rt-label>{{ 'app.stripe.expiry_date' | translate }}</rt-label>
      <div class="field" #cardExpiry></div>
    </rt-form-field>
    <rt-form-field [required]="!cardCvcComplete$.getValue()" class="card-cvc">
      <rt-label>{{ 'app.stripe.security_code' | translate }}</rt-label>
      <div class="field" #cardCvc></div>
      <span margin-top-small-xx>
        {{ 'app.stripe.x_digits_on_back' | translate: { digits: cvcDigits } }}
      </span>
    </rt-form-field>
    <div layout-align-self-center layout-horizontal layout-align-items-start>
      <rt-icon name="lock" margin-right-small-x margin-top-small-xx />
      <div layout-vertical>
        {{ 'app.stripe.secure_payment' | translate }}
        <rt-stripe-powered-by />
      </div>
    </div>
  </div>
</div>
